function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M13.024 7.723a4.545 4.545 0 0 0-.782-.641 4.588 4.588 0 0 0-5.803.641l-4.23 4.32a4.801 4.801 0 0 0-1.36 3.354c-.001 2.624 2.082 4.752 4.653 4.754a4.579 4.579 0 0 0 3.288-1.385l3.492-3.563a.343.343 0 0 0 .098-.243.336.336 0 0 0-.334-.338h-.133a5.499 5.499 0 0 1-2.128-.42.328.328 0 0 0-.363.074l-2.51 2.566a1.968 1.968 0 0 1-2.824 0 2.067 2.067 0 0 1 0-2.881l4.247-4.33a1.967 1.967 0 0 1 2.82 0 1.343 1.343 0 0 0 1.869 0 1.37 1.37 0 0 0 .385-.863 1.373 1.373 0 0 0-.385-1.045z"
}), React.createElement("path", {
  d: "M19.587 1.442a4.586 4.586 0 0 0-6.58 0L9.52 4.998a.345.345 0 0 0-.07.374c.053.127.177.21.312.207h.123a5.483 5.483 0 0 1 2.124.424.327.327 0 0 0 .362-.075l2.503-2.552a1.966 1.966 0 0 1 2.822 0c.779.796.779 2.086 0 2.881l-3.118 3.18-.026.03-1.09 1.107a1.965 1.965 0 0 1-2.819 0 1.342 1.342 0 0 0-1.868 0 1.37 1.37 0 0 0 0 1.914c.385.395.835.716 1.33.95.07.034.14.061.209.092.07.03.143.054.213.081.07.028.143.051.212.072l.196.054c.133.034.266.061.403.085.164.025.33.04.495.047h.252l.2-.023c.073-.004.15-.02.236-.02h.113l.23-.035.106-.02.192-.04h.037a4.63 4.63 0 0 0 2.157-1.25l4.23-4.32c1.818-1.855 1.818-4.864 0-6.72z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-link.ca52cf31.svg";
export { SvgComponent as ReactComponent };